document.addEventListener('DOMContentLoaded', function() {
    const numLeaves = 20;
    const leafImages = [
        'https://cdn.shopify.com/s/files/1/0750/6896/5079/files/ChatGPT_Image_Apr_14_2025_08_50_59_AM.png?v=1744635133',
        'https://cdn.shopify.com/s/files/1/0750/6896/5079/files/ChatGPT_Image_Apr_14_2025_08_50_59_AM.png?v=1744635133',
        'https://cdn.shopify.com/s/files/1/0750/6896/5079/files/ChatGPT_Image_Apr_14_2025_08_50_59_AM.png?v=1744635133',
        //https://cdn.shopify.com/s/files/1/0750/6896/5079/files/ChatGPT_Image_Apr_14_2025_08_50_59_AM.png?v=1744635133
    ];

    const container = document.body;

    function createLeaf() {
        const leaf = document.createElement('img');
        leaf.src = leafImages[Math.floor(Math.random() * leafImages.length)];
        leaf.classList.add('falling-leaf');
        leaf.style.left = `${Math.random() * 100}vw`;
        leaf.style.animationDuration = `${Math.random() * 3 + 2}s`;
        leaf.style.opacity = Math.random();
        leaf.style.transform = `scale(${Math.random() * 0.5 + 0.5})`;
        leaf.style.width = '50px'; // Establece el ancho inicial para que coincida con el CSS
        container.appendChild(leaf);

        leaf.addEventListener('animationend', function() {
            leaf.remove();
        });
    }

    for (let i = 0; i < numLeaves; i++) {
        createLeaf();
    }
});